import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';

export default <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: '2-images-with-copy',
    name: '2 Images With Copy',
    tags: ['Blog article', 'Inspiration article'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'columns',
            title: 'Columns',
            itemName: 'Column',
            defaultSize: 2,
            maxSize: 2,
            fields: [
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Column Title'
                },
                <NICmsContentField.IField>{
                    key: 'copy',
                    type: NICmsContentField.EFieldType.textarea,
                    title: 'Copy',
                    default: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. '
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link'
                },
                ...CMS_COMPONENT_CWV_CONFIG
            ]
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
